import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM } from "../../../utils/tokenVerify"
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import { Table, Select, Col, Row, Pagination, Input, Button } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../../assets/images/full-page-loader.gif"
import prevIcon from '../../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../../assets/images/icons/chevron-right.svg';
import noData from '../../../assets/images/data-graph/no-data.svg';
import TableLoader from "../.././TableLoader";
import errorData from '../../../assets/images/data-graph/error-data.svg';
import HoverCloseIcon from '../../../assets/images/icons/hover_close.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import filterIcon from '../../../assets/images/icons/filter.svg';
import tagRomoveIcon from '../../../assets/images/icons/tag_close_icon.svg';

import RemoteFeedViewEdit from "./RemoteFeedViewEdit";

const { Option } = Select;

const RemoteFeedListing = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    const [pageView, setPageView] = useState("table")

    const [siteViewId, setSiteViewId] = useState("")
    const [siteViewName, setSiteViewName] = useState("")

    const [zoneViewId, setZoneViewId] = useState("")
    const [zoneViewName, setZoneViewName] = useState("")

    const [remoteFeedViewId, setRemoteFeedViewId] = useState("")
    const [remoteFeedViewObjectId, setRemoteFeedViewObjectId] = useState("")
    const [remoteFeedViewName, setRemoteFeedViewName] = useState("")

    const [typeRf, setTypeRf] = useState("")

    const columnsAll = [

        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            // sorter: true,
            // sortDirections: ['ascend', 'descend', 'ascend'],
            fixed: 'left',
            width: 110,
            render: (text, record) => <div className='w_100 position-relative'>
                <Select
                    className={`form_select badge_content--${text ? "approved" : "declined"}`}
                    dropdownStyle={{
                        width: '12rem'
                    }}
                    value={text ? "Enabled" : "Disabled"}

                    options={
                        [{ label: "Enabled", value: "Enabled" }, { label: "Disabled", value: "Disabled" }]
                    }
                    onChange={(event) => {

                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            let token = Cookies.get("token_xapads_ssp");

                            let payload = {
                                "isEnabled": !record.status,
                                "rfId": record.rfId
                            }

                            setLoading(true)
                            axios
                                .put(configData.SERVER_URL + `remotefeed/rfStatusChange`, payload, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    setApicall(!apiCall)
                                    notifysuccess(response.data.message);

                                })
                                .catch((error) => {
                                    if (error?.response) {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message)
                                        }
                                    } else {
                                        notifycatch()
                                    }
                                    setLoading(false)
                                });
                        }
                    }
                    }
                />
            </div>,
        },
        {
            title: "Feed Id",
            dataIndex: "rfId",
            width: 100,
            key: "rfId",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            fixed: 'left',
            render: (data) => <div className='text_ellipsis align_y_d2'>{data}</div>,
        },
        {
            title: "Feed Name",
            dataIndex: "name",
            width: 250,
            key: "name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => <div className='anchor_text_link_d2'
                onClick={() => {
                    setZoneViewId(record.zoneId)
                    setZoneViewName(record.zoneName)
                    setSiteViewId(record.siteId)
                    setSiteViewName(record.siteName)
                    setRemoteFeedViewId(record.rfId)
                    setRemoteFeedViewName(record.name)
                    setRemoteFeedViewObjectId(record._id)
                    setTypeRf(record.typeRF)
                    setPageView("viewRemoteFeed")

                }}

            >{data}</div>,

        },
        {
            title: "Feed Type",
            dataIndex: "feedType",
            width: 100,
            key: "feedType",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => {
                return (
                    <>

                        <div className={`table_badges--d2 --${text === "Freewheel(4547)" ? "blue" : text === "Pubmatic DSP(887)" ? "orange" : "yellow"}`}>
                            {text}
                        </div>
                    </>
                )
            }
        },

        {
            title: "Zone Id",
            dataIndex: "zoneId",
            width: 100,
            key: "zoneId",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data) => <div className='text_dark'>{data}</div>,
        },


        {
            title: "Zone Name",
            dataIndex: "zoneName",
            width: 250,
            key: "zoneName",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data) => <div className='text_dark'>{data}</div>,
        },


        {
            title: "Locations",
            dataIndex: "locations",
            width: 200,
            key: "locations",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) =>
                // <div className='text_dark'>{data.length===0?"-":data.length<=4?data.join(","):data.slice(0, 4).join(","),+data.length-4}</div>,
                <div className='text_dark'>
                    {data.length === 0
                        ? "-"
                        : data.length <= 4
                            ? data.join(", ")
                            : data.slice(0, 4).join(", ") + `, +${data.length - 4}`}
                </div>
        },


    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")





    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .post(configData.SERVER_URL + `remotefeed/rfListing?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                    filter: filterApplyApiCall
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }
                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        BlockAM()
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };



    const handlePageViewEdit = (data, reload) => {
        if (reload === "yes") {
            setApicall(!apiCall)
        }

        setSiteViewId("")
        setSiteViewName("")

        setZoneViewId("")
        setZoneViewName("")

        setRemoteFeedViewId("")
        setRemoteFeedViewObjectId("")
        setRemoteFeedViewName("")

        setTypeRf("")

        setPageView(data)

    }





    const [filterShow, setFilterShow] = useState(false)

    const [filterApply, setFilterApply] = useState({
        status: [],
        feedType: [],
    });
    const [filterApplyApiCall, setFilterApplyApiCall] = useState({
        status: [],
        feedType: [],
    });

    useEffect(() => {
        if (!initialLoad) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            setApicall(!apiCall)
        }
    }, [filterApplyApiCall])

    function handleFilterApply(type, value) {
        let tempFilterApply = { ...filterApply }
        if (type === "status") {
            // tempFilterApply.status = [value]
            const index = filterApply.status.indexOf(value);
            if (index === -1) {
                tempFilterApply.status.push(value);
            } else {
                tempFilterApply.status.splice(index, 1);
            }

        }
        if (type === "feedType") {
            const index = filterApply.feedType.indexOf(value);
            if (index === -1) {
                tempFilterApply.feedType.push(value);
            } else {
                tempFilterApply.feedType.splice(index, 1);
            }

        }

        setFilterApply(tempFilterApply)

    }

    const dropdownRef = useRef(null);

    useEffect(() => {
        // Function to handle clicks outside the dropdown
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                let temp = JSON.parse(JSON.stringify(filterApplyApiCall));

                setFilterApply(prevState => ({
                    ...prevState,
                    status: temp.status,
                    feedType: temp.feedType,
                }));

                setFilterShow(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });



    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :
                    (filterApplyApiCall.status.length > 0 || filterApplyApiCall.feedType.length > 0) && loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        (filterApplyApiCall.status.length > 0 || filterApplyApiCall.feedType.length > 0) && !loading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>

                                    </div>
                                </div>
                            </div>
                            :
                            loading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>

                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
            }
            </>

    };


    return (
        <>


            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Remote Feeds
                    </h1>
                </div>

                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between w-100">
                                <div className="form_content_block--group">
                                    {!initialLoad &&

                                        <Input
                                            type='text'
                                            className='form_control basic md search_input w_table_search'
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {

                                                if (e.target.value.trim().length === 0) {
                                                    setLoading(true)
                                                }

                                                setSearch(e.target.value)
                                            }}
                                        />



                                    }
                                </div>

                                <div className="custom_filter_design_d2 justify_content_end --new_layout_design_btn">
                                    {!initialLoad &&
                                        <>

                                            <div className="filter_tags_design_d2">
                                                <ul className="p-0 m-0">

                                                    {filterApplyApiCall.status.length > 0 &&
                                                        <li>
                                                            <div className="d-flex">
                                                                <span className="black_text_d2">Status:</span> {filterApplyApiCall.status.join(", ")}
                                                            </div>
                                                            <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                                onClick={() => {
                                                                    let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                                    let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                                    tempFilterApply.status = []
                                                                    tempFilterApply2.status = []
                                                                    setFilterApply(tempFilterApply2)
                                                                    setFilterApplyApiCall(tempFilterApply)
                                                                }}
                                                            /> </button>
                                                        </li>
                                                    }
                                                    {filterApplyApiCall.feedType.length > 0 &&
                                                        <li>
                                                            <div className="d-flex">
                                                                <span className="black_text_d2">Feed Type:</span> {filterApplyApiCall.feedType.join(", ")}
                                                            </div>
                                                            <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                                onClick={() => {
                                                                    let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                                    let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                                    tempFilterApply.feedType = []
                                                                    tempFilterApply2.feedType = []
                                                                    setFilterApply(tempFilterApply2)
                                                                    setFilterApplyApiCall(tempFilterApply)
                                                                }}
                                                            /> </button>
                                                        </li>
                                                    }


                                                </ul>
                                            </div>


                                            <Dropdown ref={dropdownRef} show={filterShow}
                                                onToggle={() => { setFilterShow(!filterShow) }}
                                                className="" autoClose={false}>
                                                <div className="position-relative hover_effec_hide_show_d2">
                                                    <Dropdown.Toggle id="dropdown-autoclose-false">
                                                        <Button className="" icon={
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }>
                                                            Filter
                                                            {filterApplyApiCall?.status?.length + filterApplyApiCall?.feedType?.length > 0 &&
                                                                <div className="selected_filter_tag_d2">
                                                                    <div>{filterApplyApiCall?.status?.length + filterApplyApiCall?.feedType?.length}</div>
                                                                </div>
                                                            }
                                                        </Button>
                                                    </Dropdown.Toggle>
                                                    {filterApplyApiCall?.status?.length + filterApplyApiCall?.feedType?.length > 0 &&
                                                        <div className="clear_filter_icon_d2" style={{ right: '1.7rem', top: '0.8rem' }}>
                                                            <button type="button"> <img src={HoverCloseIcon} alt=""
                                                                onClick={() => {
                                                                    setFilterApply({
                                                                        status: [],
                                                                        feedType: [],
                                                                    })
                                                                    setFilterApplyApiCall({
                                                                        status: [],
                                                                        feedType: [],
                                                                    })
                                                                    setFilterShow(false)
                                                                }} />
                                                            </button>
                                                        </div>
                                                    }
                                                </div>

                                                <Dropdown.Menu>
                                                    <div className="filter_inner_heading_d2">
                                                        <p className="m-0">Status</p>
                                                        <div className="checkbox_value_select_d2">
                                                            <div className="checkbox_active_design_d2">
                                                                <input type="checkbox" name="statusenabled" id="statusenabled"
                                                                    checked={filterApply.status.includes("Enabled")}
                                                                    onChange={() => { handleFilterApply("status", "Enabled") }}
                                                                />
                                                                <label htmlFor="statusenabled" className="single_checkbox_select_d2">
                                                                    Enabled
                                                                </label>
                                                            </div>
                                                            <div className="checkbox_active_design_d2">
                                                                <input type="checkbox" name="statusdisabled" id="statusdisabled"
                                                                    checked={filterApply.status.includes("Disabled")}
                                                                    onChange={() => { handleFilterApply("status", "Disabled") }}
                                                                />
                                                                <label htmlFor="statusdisabled" className="single_checkbox_select_d2">
                                                                    Disabled
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <hr />

                                                        <p className="m-0">Feed Type</p>
                                                        <div className="checkbox_value_select_d2">
                                                            <div className="checkbox_active_design_d2">
                                                                <input type="checkbox" name="freewheelFilter" id="freewheelFilter"
                                                                    checked={filterApply.feedType.includes("Freewheel")}
                                                                    onChange={() => { handleFilterApply("feedType", "Freewheel") }}
                                                                />
                                                                <label htmlFor="freewheelFilter" className="single_checkbox_select_d2">
                                                                    Freewheel
                                                                </label>
                                                            </div>
                                                            <div className="checkbox_active_design_d2">
                                                                <input type="checkbox" name="pubmaticDspSiteAppIdFilter" id="pubmaticDspSiteAppIdFilter"
                                                                    checked={filterApply.feedType.includes("Pubmatic DSP (Site ID + App ID)")}
                                                                    onChange={() => { handleFilterApply("feedType", "Pubmatic DSP (Site ID + App ID)") }}
                                                                />
                                                                <label htmlFor="pubmaticDspSiteAppIdFilter" className="single_checkbox_select_d2">
                                                                    Pubmatic DSP (Site ID + App ID)
                                                                </label>
                                                            </div>
                                                            <div className="checkbox_active_design_d2">
                                                                <input type="checkbox" name="pubmaticDspFilter" id="pubmaticDspFilter"
                                                                    checked={filterApply.feedType.includes("Pubmatic DSP")}
                                                                    onChange={() => { handleFilterApply("feedType", "Pubmatic DSP") }}
                                                                />
                                                                <label htmlFor="pubmaticDspFilter" className="single_checkbox_select_d2">
                                                                    Pubmatic DSP
                                                                </label>
                                                            </div>

                                                        </div>




                                                        <hr />
                                                    </div>
                                                    <div className="filter_bottom_btns_d2 text-end">
                                                        <button className="reset" type='button' onClick={() => {
                                                            setFilterApply({
                                                                status: [],
                                                                feedType: [],
                                                            })
                                                            setFilterApplyApiCall({
                                                                status: [],
                                                                feedType: [],

                                                            })
                                                            setFilterShow(false)

                                                        }}>Reset</button>
                                                        <button className="apply" type='button'
                                                            onClick={() => {
                                                                let tempdata = JSON.parse(JSON.stringify(filterApply));
                                                                setFilterApplyApiCall(tempdata)
                                                                setFilterShow(false)

                                                            }}
                                                            disabled={JSON.stringify(filterApplyApiCall) === JSON.stringify(filterApply)}
                                                        >Apply</button>
                                                    </div>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <Table
                                    columns={columnsAll}
                                    pageSize={100}
                                    dataSource={data}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    // scroll={{ x: 1500, y: 'calc(100vh - 27rem' }} />
                                    scroll={{ x: 'max-content', y: 'calc(100vh - 30.9rem' }} />
                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div>



            {pageView === "viewRemoteFeed" &&
                <RemoteFeedViewEdit
                    handlePageViewChange={handlePageViewEdit}
                    siteViewId={siteViewId}
                    siteViewName={siteViewName}
                    zoneViewId={zoneViewId}
                    zoneViewName={zoneViewName}
                    remoteFeedViewId={remoteFeedViewId}
                    remoteFeedViewObjectId={remoteFeedViewObjectId}
                    remoteFeedViewName={remoteFeedViewName}
                    callingFrom="rfListing"
                    typeRf={typeRf}

                />
            }

        </>
    );
};

export default RemoteFeedListing;
